import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes.js'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.name === 'products' && from.name === 'products') {
      return { }
    }
    return { x: 0, y: 0, behavior: 'smooth' }
  }
})

export default router
